<template>
	<div class="w-full">
		<div
			class="relative mt-8 flex h-[390px] items-center overflow-clip rounded from-[#00BB83] to-[#22DF96] bg-gradient-[-30deg] md:h-[180px] xl:h-[210px]"
		>
			<div
				class="absolute -top-5 left-0 h-[190px] w-[310px] sm:-top-10 sm:left-[100px] sm:h-[220px] sm:w-[340px] md:-left-2 md:-top-8 md:w-[280px] lg:left-[40px] lg:w-[340px] xl:left-[120px] xl:w-[370px]"
			>
				<CarbarImage
					image="img/campaigns/august-ev-2025/lightning-yellow.webp"
					alt-text="August Go Green Promotion"
					image-width-class="w-auto"
					image-height-class="h-[190px] sm:h-[220px] md:h-[200px] xl:h-[240px]"
					class="animate-lightning absolute"
				/>
				<CarbarImage
					image="img/campaigns/august-ev-2025/lightning-white.webp"
					alt-text="August Go Green Promotion"
					image-width-class="w-auto "
					image-height-class="h-[190px] sm:h-[220px] md:h-[200px] xl:h-[240px]"
					class="animate-lightning-2 absolute z-40"
				/>
				<CarbarImage
					image="img/campaigns/august-ev-2025/lightning-white.webp"
					alt-text="August Go Green Promotion"
					image-width-class="w-auto "
					image-height-class="h-[190px] sm:h-[220px] md:h-[200px] xl:h-[240px]"
					class="animate-short-ping absolute z-40"
				/>
			</div>
			<div class="triangle-up absolute bottom-0" />
			<div
				class="relative top-0 flex w-full flex-col items-center justify-center gap-2 md:flex-row md:gap-0 xl:gap-4"
			>
				<div
					class="absolute -right-10 top-20 h-0.5 w-[200px] border-b border-yellow-200 sm:w-[300px] md:hidden"
				/>
				<div class="w-full md:w-[280px] lg:w-[350px] xl:w-[400px]">
					<CarbarImage
						image="img/campaigns/august-ev-2025/car.webp"
						alt-text="Tesla Model Y"
						image-width-class="w-[300px] sm:w-[330px] md:w-[330px] lg:w-[350px] xl:w-[400px]"
						image-height-class="h-auto"
						class="animate-slide-in-left relative left-5 z-10 sm:left-[120px] md:-top-2 md:left-3 lg:-left-[20px] xl:top-1"
					/>
				</div>

				<div
					class="w-full px-6 md:flex md:w-[460px] md:items-center md:gap-5 lg:gap-6 lg:px-0 xl:w-[500px] xl:gap-10"
				>
					<div class="flex flex-col">
						<p
							class="mb-2 text-center font-heading text-[1.875rem] leading-none text-[#111111] sm:text-[2.2rem] md:text-left md:text-[1.9rem] lg:mb-3 xl:text-[2.2rem]"
						>
							Go Green,
							<br />
							Get Rewarded
						</p>
						<p
							class="text-center text-[1.5rem] leading-none text-[#111111] sm:text-[1.8rem] md:mt-1 md:text-left md:text-[1.4rem] xl:text-[1.5rem]"
						>
							Make the EV switch,
						</p>
						<p
							class="text-center text-[1.5rem] font-medium leading-none text-[#111111] sm:text-[1.8rem] md:text-left md:text-[1.4rem] xl:text-[1.5rem]"
						>
							enjoy $100 charging voucher
						</p>
						<TermsAndConditions
							:is-full-width="false"
							custom-class="relative z-10 text-left hidden md:block md:mt-3 xl:mt-3"
							font-color="text-[#111111]"
						>
							*
							<CarbarLink
								text="Terms & conditions"
								text-color="text-[#111111] hover:text-gray-700"
								underline-color="hover:decoration-gray-700"
								font-size="text-xsm"
								class="cursor-pointer"
								@click="
									goToPageAndScroll(
										'/terms-and-conditions',
										'#august-go-green-promotion',
										true
									)
								"
							/>
							apply
						</TermsAndConditions>
					</div>
					<div class="relative">
						<div
							class="absolute -left-10 top-4 h-1 w-[200px] border-b border-yellow-200 sm:w-[300px] md:left-auto md:right-[120px] md:top-4 md:w-[350px] xl:top-5 xl:w-[400px]"
						/>
						<NuxtLink to="/cars/subscribe/electric">
							<div
								class="animate-glow relative z-10 mx-auto mt-4 flex w-fit items-center gap-1 rounded bg-[#F6FF4A] py-2 pl-3 pr-4 transition-all duration-300 hover:bg-[#fff534] md:-top-3.5 xl:-top-3"
							>
								<IcoLightning class="h-5 w-5" />
								<span
									class="font-medium leading-none text-[#111111]"
								>
									Find an EV
								</span>
							</div>
						</NuxtLink>
					</div>
					<TermsAndConditions
						:is-full-width="false"
						custom-class="relative z-10 mt-4 text-center md:hidden"
						font-color="text-[#111111]"
					>
						*
						<CarbarLink
							text="Terms & conditions"
							text-color="text-[#111111] hover:text-gray-700"
							underline-color="hover:decoration-gray-700"
							font-size="text-xsm"
							class="cursor-pointer"
							@click="
								goToPageAndScroll(
									'/terms-and-conditions',
									'#august-ev-promotion',
									true
								)
							"
						/>
						apply
					</TermsAndConditions>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import TermsAndConditions from '@/components/fineprint/TermsAndConditions.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'
import IcoLightning from '@/assets/svg/common/ico-lightning.svg'

const mounted = ref(false)

onMounted(() => {
	setTimeout(() => {
		mounted.value = true
	}, 50)
})
</script>

<style lang="scss">
.triangle-up {
	@apply h-0 w-0 border-b-[80px] border-l-0 border-r-[120px] border-b-[#F6FF4A] border-l-transparent border-r-transparent md:border-b-[60px] md:border-r-[180px] lg:border-b-[90px] lg:border-r-[300px];
}

.animate-lightning {
	opacity: 0;
	animation:
		// glowLoop 1s ease-in-out 1s infinite alternate,
		slide-in-from-top 0.3s ease-in 0.6s forwards;
}

.animate-lightning-2 {
	opacity: 0;
	animation: fade-in 0.3s ease-in 0.6s forwards;
}

.animate-short-ping {
	opacity: 0;
	animation:
		slide-in-from-top 0.3s ease-in 1.5s forwards,
		ping 1.5s ease-out 1s infinite;
}

.animate-slide-in-left {
	transform: translateX(-150px);
	opacity: 0;
	animation: slide-in-left 0.5s ease-out 0.3s forwards; // Added 0.4s delay
}

.animate-glow {
	animation: glowLoop 1s ease-in-out 1s infinite alternate;
}

@keyframes slideIn {
	0% {
		top: -100%;
		opacity: 0;
	}
	100% {
		top: 0%;
		opacity: 1;
	}
}

@keyframes fade-in {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}

@keyframes glowLoop {
	0% {
		filter: drop-shadow(0 0 0px yellow);
	}
	100% {
		filter: drop-shadow(0 0 45px yellow);
	}
}

@keyframes ping {
	0% {
		transform: scale(1);
		opacity: 0.6;
	}
	100% {
		transform: scale(1.5);
		opacity: 0;
	}
}

@keyframes slide-in-left {
	0% {
		opacity: 0;
		transform: translateX(-150px);
	}
	100% {
		opacity: 1;
		transform: translateX(0);
	}
}
</style>
